import { Box, Button, Card, Footer, Grommet, Header, Main, Nav, Page, PageContent, Text } from "grommet";
import { hpe } from "grommet-theme-hpe";
import { deepMerge } from "grommet/utils";
import { PageLayout } from "./components/PageLayout";
import './App.css';
import { Twitch } from "grommet-icons";
import { BrowserRouter, Route, Routes } from "react-router";
import { HomePage } from "./page/HomePage";
import { OverlayPage } from "./page/OverlayPage";

const noBorderStyle = `
  > div {
    border: none;
    > div {
      padding: 0;
    }
  }
`;

const noHoverStyle = `
  > div {
    margin: 0;
    box-shadow: unset;
  }
  > div > label:hover {
    background: unset;
  }
  > div > label {
    padding: 6px 0px;
  }
`

const mainColor = "#a6025c";
const hoverColor = "#87004a";

const theme = deepMerge(hpe, {
	global: {
    colors: {
      "decorative-brand": {
        "light": mainColor,
        "dark": mainColor
      },
      "background-primary-strong": {
        "light": mainColor,
        "dark": mainColor
      },
      "background-selected-primary-strong": {
        "light": mainColor,
        "dark": mainColor
      },
      "background-primary-strong-hover": {
        "light": mainColor,
        "dark": mainColor
      },
      "background-selected-primary-strong-hover": {
        "light": mainColor,
        "dark": mainColor
      },
      "foreground-primary": {
        "light": mainColor,
        "dark": mainColor
      },
      "decorative-green": {
        "light": mainColor,
        "dark": mainColor
      },
      "brand": {
        "dark": mainColor,
        "light": mainColor
      },
      "green": {
        "dark": hoverColor,
        "light": hoverColor
      },
      "green!": {
        "dark": mainColor,
        "light": mainColor
      },
    },
		font: {
			family: "Roboto",
			size: "18px",
			height: "20px",
		},
	},
  rangeInput: {
    thumb: {
      color: mainColor
    }
  },
  checkBox: {
    border: {
      color: mainColor
    },
    toggle: {
      color: mainColor,
    }
  },
  formField: {
      extend: ({ noBorder, noHover, noFocus }) => `
        ${noBorder ? noBorderStyle : ''}
        ${noHover ? noHoverStyle : ''}
        ${noFocus ? '> div { outline: none; }' : ''}
      `
    },
});

function App() {
	return (
    <Grommet theme={theme} full themeMode="dark" background={{ dark: true, color: '#0000' }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />}/>
          <Route path="/overlay" element={<OverlayPage />} />
        </Routes>
      </BrowserRouter>
    </Grommet>
  );
}

export default App;
